import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import { Box, IconButton, Tooltip } from "@mui/material";
import { useEffect, useState } from "react";

import { REACT_APP_POWERBI_URL } from "../../utils/env.config";

const DNADashboard = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);

    const toggleFullscreen = () => {
        setIsFullscreen(!isFullscreen);
    };

    useEffect(() => {
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape" && isFullscreen) {
                setIsFullscreen(false);
            }
        };

        if (isFullscreen) {
            document.addEventListener("keydown", handleKeyDown);
        }

        return () => {
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [isFullscreen]);

    return (
        <Box sx={{
            position: "relative",
            width: "100%",
            height: isFullscreen ? "100vh" : "calc(100vh - 64px)", // Adjust for header when not fullscreen
            ...(isFullscreen && {
                position: "fixed",
                top: 0,
                left: 0,
                zIndex: 9999,
                backgroundColor: "white"
            })
        }}>
            <Tooltip title={isFullscreen ? "Exit Fullscreen" : "Enter Fullscreen"}>
                <IconButton
                    onClick={toggleFullscreen}
                    sx={{
                        position: "absolute",
                        top: 8,
                        right: 8,
                        zIndex: 10000,
                        backgroundColor: "rgba(255, 255, 255, 0.9)",
                        "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 1)",
                        },
                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
                    }}
                >
                    {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
                </IconButton>
            </Tooltip>

            <iframe
                title="Omne DNA Country"
                src={REACT_APP_POWERBI_URL}
                allowFullScreen={true}
                style={{
                    border: "none",
                    width: "100%",
                    height: "100%"
                }}
            />
        </Box>
    );
}

export default DNADashboard;